import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { BrandsModel } from 'src/models/cars/brands';
import { API_url } from '../api.setup';

const Brands = '/brands';

const BrandsService = {
  getAllBrands: async () => {
    try {
      const response = await axios.get(`${API_url}${Brands}/getall`);
      return response.data as BrandsModel[];
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },

  addBrands: async (dataToUpdate: BrandsModel) => {
    const remodel = {
      Name: dataToUpdate.name,
      Status: dataToUpdate.status
    };
    try {
      const response = await axios.post(`${API_url}${Brands}`, remodel);
      enqueueSnackbar(`Brand "${dataToUpdate.name}" added Successfully`, {
        variant: 'success'
      });
      return response.data as BrandsModel;
    } catch (error) {
      throw error;
    }
  },

  deleteBrands: async (brandsID, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${Brands}/delete?id=${brandsID}`
      );
      enqueueSnackbar(`Brand "${data.name}" Deleted Successfully`, {
        variant: 'success'
      });

      return response.data as BrandsModel;
    } catch (error) {
      throw error;
    }
  },

  editBrands: async (editedData: BrandsModel) => {
    try {
      const response = await axios.put(
        `${API_url}${Brands}/update`,
        editedData
      );
      enqueueSnackbar(`Brand "${editedData.name}" edited Successfully`, {
        variant: 'success'
      });
      return response.data as BrandsModel;
    } catch (error) {
      throw error;
    }
  },

  uploadBrandImage: async (brandId: number, file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file); 
      const response = await axios.post(`${API_url}${Brands}/upload?brandId=${brandId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      enqueueSnackbar(`Image uploaded successfully for Brand ID ${brandId}`, {
        variant: 'success'
      });
      return response.data;
      
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },



 
};

export default BrandsService;
